import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { Box } from '../../Box/Box.js';

var NavigatorLayoutV3 = function NavigatorLayoutV3(_ref) {
  var align = _ref.align,
    acceptPointer = _ref.acceptPointer,
    visible = _ref.visible,
    disabled = _ref.disabled,
    onKeyDown = _ref.onKeyDown,
    zIndex = _ref.zIndex,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, _extends({
    pointerEvents: acceptPointer || !disabled && visible ? 'auto' : 'none',
    opacity: visible ? 1 : 0,
    transition: "opacity 0.35s ease-in-out",
    position: "absolute",
    "aria-hidden": !visible,
    zIndex: zIndex,
    onKeyDown: onKeyDown,
    top: "50%",
    transform: "translateY(-50%)"
  }, align === 'start' ? {
    left: '4px'
  } : {
    right: '4px'
  }), children);
};
var NavigatorLayoutV3Memoized = /*#__PURE__*/React.memo(NavigatorLayoutV3);
NavigatorLayoutV3Memoized.displayName = 'NavigatorLayoutV3';

export { NavigatorLayoutV3Memoized as NavigatorLayoutV3 };
//# sourceMappingURL=NavigatorLayoutV3.js.map
